import { useQuery } from "@tanstack/react-query";
import { Search, UserSearch } from "lucide-react";
import { useState } from "react";
import { api, errorMessage, unwrap } from "../../api/client";
import { Alert, Badge, Card, Empty, PageHead, Spinner } from "../../components/ui";
import { initials } from "../../lib/format";
import { useT } from "../../i18n/I18nProvider";
import { useFmt } from "./format";
import { useDebounced } from "./Orgs";

export function AdminUsers() {
  const t = useT();
  const { date, relative } = useFmt();
  const [q, setQ] = useState("");
  const query = useDebounced(q.trim());
  const users = useQuery({
    queryKey: ["admin-users", query],
    queryFn: () => unwrap(api.GET("/v1/admin/users", { params: { query: { q: query || undefined, limit: 100 } } })),
    placeholderData: (prev) => prev,
  });
  return (
    <>
      <PageHead title={t("admin.users.title")} description={t("admin.users.description")} />
      <Card pad={false}>
        <div className="toolbar">
          <div className="input-icon">
            <Search />
            <input className="input" placeholder={t("admin.users.searchPlaceholder")} value={q} onChange={(e) => setQ(e.target.value)} autoFocus />
          </div>
        </div>
        {users.isLoading ? (
          <Spinner />
        ) : users.error ? (
          <div className="card-body">
            <Alert tone="danger">{errorMessage(users.error)}</Alert>
          </div>
        ) : !users.data?.items.length ? (
          <Empty icon={<UserSearch />} title={t("admin.users.empty")} />
        ) : (
          <div className="table-wrap">
            <table className="table">
              <thead>
                <tr>
                  <th>{t("admin.users.colUser")}</th>
                  <th>{t("admin.users.colRole")}</th>
                  <th className="num hide-sm">{t("admin.users.colJoined")}</th>
                  <th className="num">{t("admin.users.colLastSignIn")}</th>
                </tr>
              </thead>
              <tbody>
                {users.data.items.map((u) => (
                  <tr key={u.id}>
                    <td>
                      <div className="row" style={{ flexWrap: "nowrap" }}>
                        <div className="org-avatar" style={{ borderRadius: 99 }}>{initials(u.display_name || u.email)}</div>
                        <div style={{ minWidth: 0 }}>
                          <div className="cell-main ellipsis" dir="auto">{u.display_name || u.email}</div>
                          <div className="cell-sub ellipsis" dir="auto">{u.display_name ? u.email : u.id}</div>
                        </div>
                      </div>
                    </td>
                    <td>{u.platform_role ? <Badge tone="grad" plain>{t("admin.users.platformAdmin")}</Badge> : <span className="faint">—</span>}</td>
                    <td className="num hide-sm">{date(u.created_at)}</td>
                    <td className="num">{relative(u.last_login_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Card>
    </>
  );
}
